import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
//import { BaseState } from '../base/base-state'
import { EditStatusType, StateHelperService } from '../../../services/proprietary/state-helper.service';
import { AddCondition, DeleteCondition, RestoreCondition, UpdateCondition } from './condition.actions';
import { ContractObjectDefaults } from './contract-object.defaults';
import { AddConditionPointer, RemoveConditionPointer } from './contract.actions';

export interface ConditionStateModel {
    condition: any;
    currentID: string;
}

@State<ConditionStateModel>({
    name: 'conditionState',
    defaults: {
        condition: {},
        currentID: null
    }
})
@Injectable()
export class ConditionState {
    constructor(private helper: StateHelperService) { }

    //******* SELECTORS *********

    @Selector()
    static fullState(state: ConditionStateModel) {
        return state.condition;
    }

    @Selector()
    static currentCondition(state: ConditionStateModel) {
        if (state.condition[state.currentID]) {
            return state.condition[state.currentID];
        } else {
            return {};
        }
    }

    @Selector()
    static conditions(state: ConditionStateModel) {
        let result: any = [];
        let mandatory = [];
        let others = [];

        for (var i in state.condition) {
            if (state.condition[i].Condition_Selection_Method == 'M') {
                mandatory.push(state.condition[i]);
            } else {
                others.push(state.condition[i]);
            }
        }

        mandatory.sort((a, b) => a.Condition_Object.Collating_Seq - b.Condition_Object.Collating_Seq);
        others.sort((a, b) => a.Condition_Object.Collating_Seq - b.Condition_Object.Collating_Seq);

        for (var i in mandatory) {
            result.push(mandatory[i]);
        }
        for (var i in others) {
            result.push(others[i]);
        }

        return result;
    }

    @Selector()
    static conditionCount(state: ConditionStateModel) {
        let count = 0;
        for (var i in state.condition) {
            count++;
        }
        return count;
    }

    //******  ACTIONS  ******

    @Action(UpdateCondition)
    updateCondition(sc: StateContext<ConditionStateModel>, action: UpdateCondition) {
        const state = sc.getState();
        let conditionID = action.Condition.Condition_ID;
        let currentCondition = state.condition[conditionID];
        let updateCondition: any = { ...action.Condition }; //need DEEP copy?  -- subloc list????
        this.helper.setItemChanged(updateCondition, state.condition[conditionID].Edit_Status);

        if (updateCondition.Edit_Status == EditStatusType.Add) {
            if (currentCondition.Selected_Ind != updateCondition.Selected_Ind && updateCondition.Selected_Ind == 'N') {
                updateCondition.Edit_Status = EditStatusType.Available;
            }
        }

        if (updateCondition.Adhoc_Ind && updateCondition.Adhoc_Ind == 'N' && currentCondition.Adhoc_Ind == 'Y') {
            updateCondition.Condition_Text = currentCondition.Condition_Object.Condition_Text;
        }

        sc.patchState({
            condition: {
                ...state.condition,
                [conditionID]: {
                    ...state.condition[conditionID],
                    ...updateCondition
                }
            }
        });

        if (updateCondition.Edit_Status != EditStatusType.Add && updateCondition.Edit_Status != EditStatusType.Available) {
            if (currentCondition.Selected_Ind != updateCondition.Selected_Ind) {
                if (updateCondition.Selected_Ind == 'N') {
                    sc.dispatch([new DeleteCondition(conditionID)]);
                } else {
                    sc.dispatch([new RestoreCondition(conditionID)]);
                }
            }
        }
    }

    @Action(DeleteCondition)
    deleteCondition(sc: StateContext<ConditionStateModel>, action: DeleteCondition) {
        const state = sc.getState();
        let condition = { ...state.condition }; //shallow copy Condition from state
        let removePointer = condition[action.conditionID] && condition[action.conditionID].Edit_Status == 'A';
        this.helper.setItemDeleted(condition, action.conditionID);
        sc.patchState({ condition: condition });
        if (removePointer) {
            sc.dispatch(new RemoveConditionPointer(action.conditionID.toString()));
        }
    }

    @Action(RestoreCondition)
    restoreCondition(sc: StateContext<ConditionStateModel>, action: RestoreCondition) {
        const state = sc.getState();
        let condition = { ...state.condition }; //shallow copy Condition from state
        this.helper.setItemRestored(condition, action.conditionID);
        condition[action.conditionID].Selected_Ind = 'Y';
        sc.patchState({ condition: condition });
    }

    @Action(AddCondition)
    addCondition(sc: StateContext<ConditionStateModel>, action: AddCondition) {
        const state = sc.getState();

        let conditionID: number = null;
        let duplicate = false;

        let newCondition = this.helper.createDefaultItem(ContractObjectDefaults, 'Contract_Condition', action.Condition);
        if (newCondition && newCondition.Condition_ID) {
            conditionID = parseInt(newCondition.Condition_ID, 10);
        }
        if (!conditionID || conditionID == null || conditionID <= 0) {
            throw 'Condition_ID must be provided for a condition add!';
        } else {
            for (var i in state.condition) {
                if (state.condition[i].Condition_ID.toString() == conditionID.toString()) {
                    duplicate = true;
                    break;
                }
            }

            if (!duplicate) {
                this.helper.setItemAdded(newCondition);
                newCondition.Condition_ID = conditionID.toString(); //Stored as a string in state.
                sc.patchState({
                    currentID: conditionID.toString(),
                    condition: { ...state.condition, [conditionID]: newCondition }
                });
                sc.dispatch(new AddConditionPointer(conditionID.toString()));
            }
        }
    }
}
